import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./GreenBenefits.css";

const cards = [
  {
    icon: <img src="/icons/personal.webp" alt="Efficiency" />,
    title: "E-COMMERCE PERSONALIZATION",
    desc: "Craft personalized shopping experiences using data analytics and machine learning. Boost engagement and conversions by recommending tailored products and promotions across digital channels."
  },
  {
    icon: <img src="/icons/web.png" alt="Sustainability" />,
    title: "SMART INVENTORY MANAGEMENT",
    desc: "Monitor stock levels in real-time with IoT sensors and analytics. Optimize replenishment, prevent stockouts, and cut costs by forecasting demand accurately."
  },
  {
    icon: <img src="/icons/banking.webp" alt="Engagement" />,
    title: "CONTACTLESS PAYMENT SOLUTIONS",
    desc: "Offer secure NFC, mobile wallet, and QR code payments. Simplify checkouts, enhance security, and meet evolving consumer preferences for safe transactions."
  }
];

export default function GreenBenefits({ imageSrc }) {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="green-benefits-section" id="benefits">
      <div className="green-benefits-top">
        <div className="green-benefits-text" data-aos="fade-right">
          <div className="green-benefits-title">
            DIGITAL ACCELERATION<br />
            <span className="green-benefits-title-blue">IN RETAIL</span>
          </div>
          <div className="green-benefits-desc">
            Whether you are focused on e-commerce, optimizing your supply chain or managing your inventory, our solutions provide comprehensive tools to meet your specific needs. Unlock the potential of technology and embrace digital transformation in the Retail industry.
          </div>
        </div>
        <div className="green-benefits-image" data-aos="fade-left">
          <img src={imageSrc} alt="Digital Acceleration" />
        </div>
      </div>
      <div className="green-benefits-cards">
        {cards.map((card, i) => (
          <div
            className="green-benefits-card"
            key={i}
            data-aos="fade-up"
            data-aos-delay={100 + i * 100}
          >
            <div className="green-benefits-card-icon">{card.icon}</div>
            <div className="green-benefits-card-title">{card.title}</div>
            <div className="green-benefits-card-desc">{card.desc}</div>
          </div>
        ))}
      </div>
      <div className="green-benefits-btn-row" data-aos="fade-up" data-aos-delay="500">
        <button className="green-benefits-btn">
          MORE ABOUT DIGITAL ACCELERATION
        </button>
      </div>
    </section>
  );
}